import React, { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router';
import { useTranslate } from '../../components/TranslationText';
import { toast, ToastContainer } from 'react-toastify';
import { eFormButtonsContainer, eformInput, eformTerms, noDataCard, serviceRequestHeadContainer, serviceRequestTitle } from '../../common/cssclasses';
import EahsForm from '../../components/EahsForm';
import NetaqInput from '../../components/NetaqInput';
import Loader from '../../components/Loader';
import SubmitServiceBtn from '../../components/servicesButtons/SubmitServiceBtn';
import CustomPopUp from '../../components/CustomPopUp';
import SimpleUpload from '../../components/SimpleFileUpload';
import { isEmpty, validateInputs } from '../../helper/validaiteInputs';
import { getFontCompetitionDetails, getFonts, submitFontCompetition } from './fontCompetitionApi/fontCompetitionApi';
import { Link } from 'react-router-dom';
import ReCAPTCHA from 'react-google-recaptcha';
import { isProduction } from '../../helper/isProduction';

const recaptchaSiteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export default function FontCompetitionPage() {
    const lang = localStorage.getItem('eahsLang')??'en';
    const location = useLocation();
    const navigate = useNavigate();
    const { translate } = useTranslate();
    const searchParams = new URLSearchParams(location.search);
    const currentId = searchParams.has("id") ? searchParams.get("id") : null;

    const [competitionDetails, setCompetitionDetails] = useState({});
    const [sampleOfWork, setSampleOfWork] = useState([]);
    const [idFile, setIdFile] = useState([]);
    const [loading, setLoading] = useState(false);
    const [acceptTerms, setAcceptTerms] = useState(false);
    const recaptchaRef = useRef();
    const [recaptchaToken, setRecaptchaToken] = useState(isProduction ? "" : null);
    const [recaptchaValidate, setRecaptchaVaidate] = useState(!isProduction);


    const initialState = {
        FullNameAr: '',
        Email: '',
        Mobile: '',
        BirthDate: '',
        FontType: '',
    };

    const [formData, setFormData] = useState(initialState);
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);

    const yesNoOptions = [
        {
            label: translate('web.yes', 'Yes'),
            text: translate('web.yes', 'Yes'),
            value: true,
        },
        {
            label: translate('web.no', 'no'),
            text: translate('web.no', 'no'),
            value: false,
        },
    ];
    const [fontTypes, setFontTypes] = useState([]);

    const handleUpload = (e, setData) => {
        if (e.target.files && e.target.files.length > 0) {
            let checkFileSize = true;
            const fileListHook = [];

            for (let fileIndex = 0; fileIndex < e.target.files.length; fileIndex++) {
                if (e.target.files[fileIndex].size > 10 * 1024 * 1024) {
                    checkFileSize = false;
                    toast.error(translate("web.fileSizeLimit", "File size 10MB limit."));
                } else {
                    // Check allowed file types
                    const file = e.target.files[fileIndex];
                    const allowedMimeTypes = ['image/', 'application/pdf'];

                    if (!allowedMimeTypes.some(type => file.type.startsWith(type))) {
                        toast.error(translate("web.invalidFileType", "Only images and PDFs allowed."));
                        continue; // Skip to the next file if type is not allowed
                    }

                    fileListHook.push({
                        documentFile: URL.createObjectURL(e.target.files[fileIndex]),
                        name: e.target.files[fileIndex].name,
                        file: e.target.files[fileIndex],
                    });
                }
            }
            setData(fileListHook);
        }
    };


    const setPhoneNumber = (value) => {
        setFormData((prev) => ({
            ...prev,
            'Mobile': value
        }));
    }

    const handleChange = (event) => {
        setFormData((prev) => ({
            ...prev,
            [event.target.name]: event.target.value,
        }));
    }

    async function submitForm() {
        if (isPhoneNumberValid == false) {
            return;
        }
        try {
            const valid = validateInputs(formData, toast, translate)
            if (valid) {
                const sendFormData = new FormData();
                if (formData?.hasOwnProperty("HasExperince") == false) {
                    const message = translate('web.HasExperince', 'Has Experince') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                if (formData?.HasExperince == true) {
                    if (isEmpty(formData?.ExperinceText)) {
                        const message = translate('web.ExperinceText', 'Experince Text') + " " + translate('web.isRequired')
                        toast.error(message);
                        return;
                    }
                }
                if (formData?.hasOwnProperty("ParticipatedInSimilarCompetition") == false) {
                    const message = translate('web.ParticipatedInSimilarCompetition', 'Participated In Similar Competition') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                if (formData?.ParticipatedInSimilarCompetition == true) {
                    if (isEmpty(formData?.SimilarCompetitions)) {
                        const message = translate('web.SimilarCompetitions', 'Similar Competitions') + " " + translate('web.isRequired')
                        toast.error(message);
                        return;
                    }
                }
                if (formData.FontType == "5") {
                    if (isEmpty(formData?.Other)) {
                        const message = translate('web.FontType', 'FontType') + " " + translate('web.Other', 'Other') + " " + translate('web.isRequired')
                        toast.error(message);
                        return;
                    }
                }
                if (idFile?.length <= 0) {
                    const message = translate('web.IdFile', 'Id File') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                if (sampleOfWork?.length <= 0) {
                    const message = translate('web.sampleOfYourWork', 'Sample Of Your Work') + " " + translate('web.isRequired')
                    toast.error(message);
                    return;
                }
                setLoading(true)
                sendFormData.append('CompetitionId', currentId);
                sendFormData.append('Name', formData?.FullNameAr);
                sendFormData.append('Mobile', formData?.Mobile);
                sendFormData.append('Email', formData?.Email);
                sendFormData.append('BirthDate', formData?.BirthDate);
                sendFormData.append('IsExperienced', formData?.HasExperince);
                if (formData?.HasExperince == true) {
                    sendFormData.append('ExperienceYears', formData?.ExperinceText);
                    sendFormData.append('PortfolioSampleFile', sampleOfWork[0].file ?? null);
                }
                sendFormData.append('HasPriorCompetitions', formData?.ParticipatedInSimilarCompetition);
                if (formData?.ParticipatedInSimilarCompetition == true) {
                    sendFormData.append('PriorSimilarCompetitions', formData?.SimilarCompetitions);
                }
                if (formData?.FontType != "5") {
                    sendFormData.append('CalligraphyStyle', formData?.FontType);
                } else {
                    sendFormData.append('CalligraphyStyle', formData?.FontType);
                    sendFormData.append('CalligraphyStyleOther', formData?.Other);
                }
                sendFormData.append('IdFile', idFile[0].file ?? null);
                sendFormData.append('GoogleRecaptchaResponse', isProduction ? recaptchaToken : (recaptchaToken || null));

                const send = await submitFontCompetition(sendFormData);
                if (send == false) {
                    toast.error(translate('web.errorInSubmitting', 'Error In Submitting'))
                } else {
                    const res = send;
                    if (res?.data?.result == true) {
                        toast.success(translate('web.dataSavedSuccessfully', 'Data Saved Successfully'));
                        resetForm();
                        setTimeout(() => {
                            navigate('/');
                        }, 3000);
                    } else {
                        const errorMsg = res?.data?.status?.detailedResponseCode ?? 'error';
                        toast.error(translate(`${errorMsg}`, errorMsg));
                    }
                }

                setLoading(false)
            } else {
                setLoading(false)
                return;
            }
        } catch (error) {
            setLoading(false)
        }
    }


    useEffect(() => {
        getFonts().then(res => {
            setFontTypes(res);
        })
        getFontCompetitionDetails(currentId).then(res => {
            setCompetitionDetails(res);
        })
    }, [])
   

    function resetForm() {
        setFormData(initialState);
        setIdFile([])
        setSampleOfWork([])
    }
    return (
        <>
            <ToastContainer
                position="top-right"
                closeOnClick
                theme="colored"
                autoClose={5000}
            />
            <div className='row rtl mb-main'>
                <h2 className='col-12 fw-bold'>
                    {translate('web.registerFor', 'Register For') + " " + (!!competitionDetails?.name ? competitionDetails?.name : '')}
                </h2>
                <div className='col-12 row'>
                    {!!competitionDetails?.startDate &&
                        <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                            <i className="fa fa-calendar C89C66" style={{ margin: "0px 5px" }}></i>
                            {translate('web.startDate', 'Start Date')}:
                            <span className='ms-1'>{competitionDetails?.startDate}</span>
                        </div>
                    }
                    {!!competitionDetails?.endDate &&
                        <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                            <i className="fa fa-calendar C89C66" style={{ margin: "0px 5px" }}></i>
                            {translate('web.endDate', 'end Date')}:
                            <span className='ms-1'>{competitionDetails?.endDate}</span>
                        </div>
                    }
                    {!!competitionDetails?.address &&
                        <>
                            {!!competitionDetails?.mapLocationUrl ?
                                <Link to={competitionDetails?.mapLocationUrl} target="_blank" className="col-md-2  showDetaisLabel C89C66 " style={{ width: 'unset' }}>
                                    <i className="fa fa-location-dot C89C66" ></i>
                                    <span className='ms-1'>{competitionDetails?.address}</span>
                                </Link> :
                                <div className="col-md-2  showDetaisLabel " style={{ width: 'unset' }}>
                                    <i className="fa fa-location-dot C89C66" ></i>
                                    <span className='ms-1'>{competitionDetails?.address}</span>
                                </div>
                            }
                        </>
                    }
                </div>
            </div>

            {competitionDetails?.isOpen ?
                <>
                    <EahsForm isSectionTitle className={'mb-main'} ish3 >
                        <div className={eformInput}>
                            <NetaqInput
                                type='text'
                                name='FullNameAr'
                                label={translate('web.FullNameAr', 'Full Name Ar')}
                                placeholder={translate('web.FullNameAr', 'Full Name Ar')}
                                required
                                onChange={handleChange}
                            />
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                type={'phone'}
                                label={translate("web.mobileNo", "Mobile No")}
                                name={'phone'}
                                placeholder={'971xxxxxxxxx'}
                                required={true}
                                onChange={setPhoneNumber}
                                setIsPhoneNumberValid={setIsPhoneNumberValid} />
                            {!isPhoneNumberValid &&
                                <div className='text-danger'>
                                    {translate('web.phoneNumberIsNotValid', 'Phone Number Is Not Valid')}
                                </div>}
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                type='email'
                                name='Email'
                                label={translate('web.Email', 'Email')}
                                placeholder={translate('web.Email', 'Email')}
                                required
                                onChange={handleChange}
                            />
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                type='normalDate'
                                name='BirthDate'
                                label={translate('web.birthDate', 'BirthDate')}
                                placeholder={translate('web.birthDate', 'BirthDate')}
                                required
                                onChange={handleChange}
                            />
                        </div>
                        <div className={eformInput}>
                            <label className="capatalize_text">
                                {translate('web.idFile', 'Id File')} <span className="color-eahsred" >*</span>
                            </label>
                            <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={idFile} onChange={(e) => handleUpload(e, setIdFile)} key={'idFile'} />
                        </div>
                        <div className={eformInput}>
                            <NetaqInput
                                key={'hasExperince'}
                                type='select'
                                name='hasExperince'
                                label={translate('web.hasExperince', 'hasExperince')}
                                placeholder={translate('web.hasExperince', 'hasExperince')}
                                listSelect={yesNoOptions}
                                required
                                onChange={(selectItem) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        HasExperince: selectItem.value,
                                    }));
                                }}
                            />
                        </div>
                        {formData.HasExperince == true &&
                            <>
                                <div className={eformInput}>
                                    <NetaqInput
                                        type='text'
                                        name='ExperinceText'
                                        label={translate('web.ExperinceText', 'ExperinceText')}
                                        placeholder={translate('web.ExperinceText', 'ExperinceText')}
                                        required
                                        onChange={handleChange}
                                    />
                                </div>
                                <div className={eformInput}>
                                    <label className="capatalize_text">
                                        {translate('web.sampleOfYourWork', 'Sample of your work')} <span className="color-eahsred" >*</span>
                                    </label>
                                    <SimpleUpload accept="image/*,application/pdf" isMulti={false} isServer={false} initialFiles={sampleOfWork} onChange={(e) => handleUpload(e, setSampleOfWork)} key={'Sample of your work'} />
                                </div>
                            </>

                        }
                        <div className={eformInput}>
                            <NetaqInput
                                key={'ParticipatedInSimilarCompetition'}
                                type='select'
                                name='ParticipatedInSimilarCompetition'
                                label={translate('web.ParticipatedInSimilarCompetition', 'ParticipatedInSimilarCompetition')}
                                placeholder={translate('web.ParticipatedInSimilarCompetition', 'ParticipatedInSimilarCompetition')}
                                listSelect={yesNoOptions}
                                required
                                onChange={(selectItem) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        ParticipatedInSimilarCompetition: selectItem.value,
                                    }));
                                }}
                            />
                        </div>
                        {formData.ParticipatedInSimilarCompetition == true &&
                            <div className={eformInput}>
                                <NetaqInput
                                    type='text'
                                    name='SimilarCompetitions'
                                    label={translate('web.SimilarCompetitions', 'SimilarCompetitions')}
                                    placeholder={translate('web.SimilarCompetitions', 'SimilarCompetitions')}
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                        }
                        <div className={eformInput}>
                            <NetaqInput
                                key={'fontType'}
                                type='select'
                                name='FontType'
                                label={translate('web.FontType', 'FontType')}
                                placeholder={translate('web.FontType', 'FontType')}
                                listSelect={fontTypes}
                                required
                                onChange={(selectItem) => {
                                    setFormData((prev) => ({
                                        ...prev,
                                        FontType: selectItem.value,
                                    }));
                                }}
                            />
                        </div>

                        {formData.FontType == "5" &&
                            <div className={eformInput}>
                                <NetaqInput
                                    type='text'
                                    name='Other'
                                    label={translate('web.FontType', 'FontType') + " " + translate('web.Other', 'Other')}
                                    placeholder={translate('web.FontType', 'FontType') + " " + translate('web.Other', 'Other')}
                                    required
                                    onChange={handleChange}
                                />
                            </div>
                        }


                        {!!competitionDetails?.termsAndConditions &&
                            <div className={eformTerms + " my-3"}>
                                <CustomPopUp
                                    key={'terms'}
                                    trigger={
                                        <NetaqInput
                                            key={'termsAndConditions' + "123"}
                                            type='checkbox'
                                            name='termsAndConditions'
                                            label={translate('web.iAgreeToTheTermsAndConditions', 'I Agree To The Terms And Conditions')}
                                            checked={acceptTerms}
                                            onChange={(e) => setAcceptTerms(e?.target?.checked)}
                                        />
                                    }
                                    title={translate('web.termsAndConditions', 'Terms And Conditions')}
                                    content={
                                        <>
                                            <div dangerouslySetInnerHTML={{ __html: competitionDetails?.termsAndConditions }} />
                                        </>
                                    }
                                />
                            </div>
                        }
                        {isProduction && (
                            <ReCAPTCHA
                                sitekey={recaptchaSiteKey}
                                size="normal"
                                hl={lang}
                                ref={recaptchaRef}
                                onChange={(token) => {
                                    if (recaptchaValidate == false) {
                                        setRecaptchaToken(token);
                                        setRecaptchaVaidate(true);
                                    }
                                }}
                            />
                        )}
                    </EahsForm>

                    <div className={eFormButtonsContainer}>
                        {/* submit btn */}
                        {loading ?
                            <Loader /> :
                            <SubmitServiceBtn
                                onClick={submitForm}
                                disabled={!acceptTerms || !recaptchaValidate}
                            />
                        }
                    </div>
                </>
                :
                <>
                    <div className='row rtl mt-3' >
                        <div className={noDataCard}>
                            <h4 className='text-danger text-center'>
                                {translate('web.sorryRegistrationIsNotOpenNow', 'Sorry Registration Is Not Open Now')}
                            </h4>
                        </div>
                    </div>
                </>
            }
        </>
    )
}
